import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const TwoFactorContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const TwoFactorIcon = styled(Box)(() => ({
  marginBottom: "32px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const TwoFactorTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
  color: "#1B252F",
}));

export const TwoFactorSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  marginBottom: "44px",
  maxWidth: "400px",
}));

export const TwoFactorForm = styled("form")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
}));

export const TwoFactorActions = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  marginTop: "16px",
}));

export const SmsConsentText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontSize: "12px",
  fontFamily: "Nunito",
  fontWeight: 400,
  lineHeight: "18px",
  marginTop: "8px",
}));

export const SmsConsentLinks = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  marginTop: "8px",
  flexWrap: "nowrap",
  whiteSpace: "nowrap",
}));

export const SmsConsentLink = styled("a")(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "12px",
  fontFamily: "Nunito",
  fontWeight: 400,
  textDecoration: "none",
  lineHeight: "18px",
  "&:hover": {
    color: theme.palette.text.primary,
    textDecoration: "underline",
  },
}));
